import { render, staticRenderFns } from "./carouselCom.vue?vue&type=template&id=672abf89&scoped=true"
import script from "./carouselCom.vue?vue&type=script&lang=ts"
export * from "./carouselCom.vue?vue&type=script&lang=ts"
import style0 from "./carouselCom.vue?vue&type=style&index=0&id=672abf89&prod&lang=scss&scoped=true"
import style1 from "./carouselCom.vue?vue&type=style&index=1&id=672abf89&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672abf89",
  null
  
)

export default component.exports